<div class="component-container" *ngIf="showPowerPlantProtectionSection()">
  <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column margin-align">
    <div class="margin-header-align section-heading text-uppercase">
      <app-section-header [title]="'grid-comp.power-plant-title' | translate"></app-section-header>
      <div class="section-buttons">
        <lock-unlock-buttons
          [showLockButton]="isDetailsView"
          [showUnlockButton]="isDetailsView"
          [isLocked]="getSectionLocked()"
          [areButtonsDisabled]="!(isModeratorRole() && editabilityBasedOnProcessStatus.internalRoles)"
          (lockButtonClickedEvent)="lockSection()"
          (unLockButtonClickedEvent)="unlockSection()"></lock-unlock-buttons>
        <i
          *ngIf="isDetailsView"
          class="pi pi-comment"
          [ngClass]="isCommentVisible || getSectionComment() ? 'lock-icon-style' : 'unlock-icon-style'"
          [pTooltip]="showCommentTooltip() ? ('comment-section.comment-tooltip' | translate) : null"
          [tooltipPosition]="showCommentTooltip() ? 'bottom' : null"
          (click)="showComment()"></i>
      </div>
    </div>
  </div>
  <section-comment
    [isCommentTextInputVisible]="isModeratorRole() && (isCommentVisible || getSectionComment())"
    [isCommentTextVisible]="!isModeratorRole()"
    [isCommentSaveVisible]="!getSectionComment()"
    [isCommentDeleteButtonDisabled]="!editabilityBasedOnProcessStatus.internalRoles"
    [comment]="getSectionComment()"
    (saveCommentEvent)="updateComment($event)"
    (deleteCommentEvent)="deleteComment()"
    (changeTextEvent)="changeCommentText.emit($event)"></section-comment>
  <div class="form-background margin-align" [ngClass]="getSectionLocked() !== true || !applicationId ? '' : 'disable-section'">
    <div class="top-bottom-margin">
      <div *ngIf="isIntegratedGridProtection">
        <div *ngFor="let integratedGridDoc of generatorGridProtectionDocuments; index as i">
          <label>{{ 'grid-comp.documents-generator' | translate }} {{ i + 1 }}</label>
          <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 mt-3 field-padding section-field">
            <label class="ui-g-5" [ngClass]="{ required: documentsRequired }">
              {{ 'grid-comp.certificate-integrated-gp' | translate }}
            </label>
            <app-file-upload
              class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-6"
              [fileData]="integratedGridDoc.documents[0]"
              [type]="documentTypes.IntegratedCertificate"
              [isDetailsView]="(isDetailsView && integratedGridDoc?.documents[0]?.document_id) || isModeratorRole() || role === 'observer'"
              [isClearButtonDisabled]="isSectionDisabled"
              [isUploadDisabled]="isSectionDisabled"
              [inputName]="'generator_integrated_grid_protection_cert' + i"
              (clearFileEvent)="clearFile($event)"
              [isRequired]="documentsRequired && !isModeratorRole()"></app-file-upload>
          </div>
          <div
            class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 field-padding section-field"
            [class]="
              technicalData.grid_power_plant_protection_data.integrated_grid_protection_documents.length > 0 &&
              technicalData.grid_power_plant_protection_data.integrated_grid_protection_documents.length - 1 !== i
                ? 'bottom-border mb-2'
                : ''
            ">
            <label class="ui-g-5" [ngClass]="{ required: documentsRequired }">
              {{ 'grid-comp.audit-integrated-gp' | translate }}
            </label>
            <app-file-upload
              class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-6"
              [fileData]="integratedGridDoc.documents[1]"
              [type]="documentTypes.IntegratedAudit"
              [isDetailsView]="(isDetailsView && integratedGridDoc?.documents[1]?.document_id) || isModeratorRole() || role === 'observer'"
              [isClearButtonDisabled]="isSectionDisabled"
              [isUploadDisabled]="isSectionDisabled"
              [inputName]="'generator_integrated_grid_protection_audit' + i"
              (clearFileEvent)="clearFile($event)"
              [isRequired]="documentsRequired && !isModeratorRole()"></app-file-upload>
          </div>
        </div>
        <div *ngFor="let integratedGridDoc of inverterGridProtectionDocuments; index as i">
          <label>{{ 'grid-comp.documents-inverter' | translate }} {{ i + 1 }}</label>
          <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 mt-3 field-padding section-field">
            <label class="ui-g-5" [ngClass]="{ required: documentsRequired }">
              {{ 'grid-comp.certificate-integrated-gp' | translate }}
            </label>
            <app-file-upload
              class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-6"
              [fileData]="integratedGridDoc.documents[0]"
              [type]="documentTypes.IntegratedCertificate"
              [isDetailsView]="(isDetailsView && integratedGridDoc?.documents[0]?.document_id) || isModeratorRole() || role === 'observer'"
              [isClearButtonDisabled]="isSectionDisabled"
              [isUploadDisabled]="isSectionDisabled"
              [inputName]="'inverter_integrated_grid_protection_cert' + i"
              (clearFileEvent)="clearFile($event)"
              [isRequired]="documentsRequired && !isModeratorRole()"></app-file-upload>
          </div>
          <ng-container *ngIf="showE7AuditReportInverter">
            <div
              class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 field-padding section-field"
              [class]="
                technicalData.grid_power_plant_protection_data.integrated_grid_protection_documents.length > 0 &&
                technicalData.grid_power_plant_protection_data.integrated_grid_protection_documents.length - 1 !== i
                  ? 'bottom-border mb-2'
                  : ''
              ">
              <label class="ui-g-5" [ngClass]="{ required: documentsRequired }">
                {{ 'grid-comp.audit-integrated-gp' | translate }}
              </label>
              <app-file-upload
                class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-6"
                [fileData]="integratedGridDoc.documents[1]"
                [type]="documentTypes.IntegratedAudit"
                [isDetailsView]="
                  (isDetailsView && integratedGridDoc?.documents[1]?.document_id) || isModeratorRole() || role === 'observer'
                "
                [isClearButtonDisabled]="isSectionDisabled"
                [isUploadDisabled]="isSectionDisabled"
                [inputName]="'inverter_integrated_grid_protection_audit' + i"
                (clearFileEvent)="clearFile($event)"
                [isRequired]="documentsRequired && !isModeratorRole()"></app-file-upload>
            </div>
          </ng-container>
        </div>
        <div *ngFor="let integratedGridDoc of converterGridProtectionDocuments; index as i">
          <label>{{ 'grid-comp.documents-converter' | translate }} {{ i + 1 }}</label>
          <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 mt-3 field-padding section-field">
            <label class="ui-g-5" [ngClass]="{ required: documentsRequired }">
              {{ 'grid-comp.certificate-integrated-gp' | translate }}
            </label>
            <app-file-upload
              class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-6"
              [fileData]="integratedGridDoc.documents[0]"
              [type]="documentTypes.IntegratedCertificate"
              [isDetailsView]="(isDetailsView && integratedGridDoc?.documents[0]?.document_id) || isModeratorRole() || role === 'observer'"
              [isClearButtonDisabled]="isSectionDisabled"
              [isUploadDisabled]="isSectionDisabled"
              [inputName]="'converter_integrated_grid_protection_cert' + i"
              (clearFileEvent)="clearFile($event)"
              [isRequired]="documentsRequired && !isModeratorRole()"></app-file-upload>
          </div>
          <div
            class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 field-padding section-field"
            [class]="
              technicalData.grid_power_plant_protection_data.integrated_grid_protection_documents.length > 0 &&
              technicalData.grid_power_plant_protection_data.integrated_grid_protection_documents.length - 1 !== i
                ? 'bottom-border mb-2'
                : ''
            ">
            <label class="ui-g-5" [ngClass]="{ required: documentsRequired }">
              {{ 'grid-comp.audit-integrated-gp' | translate }}
            </label>
            <app-file-upload
              class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-6"
              [fileData]="integratedGridDoc.documents[1]"
              [type]="documentTypes.IntegratedAudit"
              [isDetailsView]="(isDetailsView && integratedGridDoc?.documents[1]?.document_id) || isModeratorRole() || role === 'observer'"
              [isClearButtonDisabled]="isSectionDisabled"
              [isUploadDisabled]="isSectionDisabled"
              [inputName]="'converter_integrated_grid_protection_audit' + i"
              (clearFileEvent)="clearFile($event)"
              [isRequired]="documentsRequired && !isModeratorRole()"></app-file-upload>
          </div>
        </div>
      </div>
      <div *ngIf="isCentralGridProtection" class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 field-padding section-field">
        <label class="ui-g-5" [ngClass]="{ required: documentsRequired }">
          {{ 'grid-comp.certificate-central-gp' | translate }}
        </label>
        <app-file-upload
          class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-6"
          [fileData]="technicalData.grid_power_plant_protection_data.central_grid_protection_documents[0]"
          [type]="documentTypes.CentralCertificate"
          [isDetailsView]="
            isDetailsView && technicalData.grid_power_plant_protection_data.central_grid_protection_documents[0]?.document_id
          "
          [isClearButtonDisabled]="isSectionDisabled"
          [isUploadDisabled]="isSectionDisabled"
          [inputName]="'central_grid_protection_cert'"
          (clearFileEvent)="clearFile($event)"
          [isRequired]="documentsRequired && !isModeratorRole()"></app-file-upload>
      </div>
      <div *ngIf="isCentralGridProtection" class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 field-padding section-field">
        <label class="ui-g-5" [ngClass]="{ required: documentsRequired }">
          {{ 'grid-comp.audit-central-gp' | translate }}
        </label>
        <app-file-upload
          class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-6"
          [fileData]="technicalData.grid_power_plant_protection_data.central_grid_protection_documents[1]"
          [type]="documentTypes.CentralAudit"
          [isDetailsView]="
            isDetailsView && technicalData.grid_power_plant_protection_data.central_grid_protection_documents[1]?.document_id
          "
          [isClearButtonDisabled]="isSectionDisabled"
          [isUploadDisabled]="isSectionDisabled"
          [inputName]="'central_grid_protection_audit'"
          (clearFileEvent)="clearFile($event)"
          [isRequired]="documentsRequired && !isModeratorRole()"></app-file-upload>
      </div>
    </div>
  </div>
</div>
